// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form_gZRrj {
  min-height: 50vh !important;
  width: 496px;
  padding: var(--size-padXLarge) !important;
  display: flex;
  flex-direction: column;
  gap: var(--size-padMedium);
}

.dialog_tI85F {
  width: 600px;
}

.header_qnonF {
  width: 100%;
  padding: var(--size-pad12) var(--size-padLarge);
}

.headerIcon_Oj_ZQ {
  width: 24px;
  height: 24px;
}

@media only screen and (max-width: 1023px) {
  .form_gZRrj {
    width: 100%;
    max-height: 80vh;
  }

  .dialog_tI85F {
    margin: 0 var(--size-pad12);
  }
}

.contentHeaderFlex_yEpT5 {
  padding-top: 8px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 8px;
  background-color: white;
  border-bottom: 1px solid var(--color-base100);
}

.contentArea_i69dZ {
  padding-top: 8px;
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.padding_FGiqF {
  width: 540px;
}

.name_G0fZx, .roles_OIdMv {
  font-weight: 600 !important;
}

.roles_OIdMv {
  color: var(--color-base600) !important;
}

.usersCount_TyoBb {
  font-weight: 700;
  color: var(--color-base600) !important;
}

.validPhone_lFJeN {
  color: var(--color-success700) !important;
}

.invalidPhone_TpyZt {
  color: var(--color-danger700) !important;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/alerts/views/SendPendingSaleMessageScreen.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":[".form {\n  min-height: 50vh !important;\n  width: 496px;\n  padding: var(--size-padXLarge) !important;\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-padMedium);\n}\n\n.dialog {\n  width: 600px;\n}\n\n.header {\n  width: 100%;\n  padding: var(--size-pad12) var(--size-padLarge);\n}\n\n.headerIcon {\n  width: 24px;\n  height: 24px;\n}\n\n@media only screen and (max-width: 1023px) {\n  .form {\n    width: 100%;\n    max-height: 80vh;\n  }\n\n  .dialog {\n    margin: 0 var(--size-pad12);\n  }\n}\n\n.contentHeaderFlex {\n  padding-top: 8px;\n  padding-left: 16px;\n  padding-right: 16px;\n  padding-bottom: 8px;\n  background-color: white;\n  border-bottom: 1px solid var(--color-base100);\n}\n\n.contentArea {\n  padding-top: 8px;\n  padding-left: 16px;\n  padding-right: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.padding {\n  width: 540px;\n}\n\n.name, .roles {\n  font-weight: 600 !important;\n}\n\n.roles {\n  color: var(--color-base600) !important;\n}\n\n.usersCount {\n  font-weight: 700;\n  color: var(--color-base600) !important;\n}\n\n.validPhone {\n  color: var(--color-success700) !important;\n}\n\n.invalidPhone {\n  color: var(--color-danger700) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `form_gZRrj`,
	"dialog": `dialog_tI85F`,
	"header": `header_qnonF`,
	"headerIcon": `headerIcon_Oj_ZQ`,
	"contentHeaderFlex": `contentHeaderFlex_yEpT5`,
	"contentArea": `contentArea_i69dZ`,
	"padding": `padding_FGiqF`,
	"name": `name_G0fZx`,
	"roles": `roles_OIdMv`,
	"usersCount": `usersCount_TyoBb`,
	"validPhone": `validPhone_lFJeN`,
	"invalidPhone": `invalidPhone_TpyZt`
};
export default ___CSS_LOADER_EXPORT___;
